<template>
    <AppLayout title="Penyusunan Dokumen Pemilihan">
        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Accordion
                                    :multiple="true"
                                    :activeIndex="[0, 1, 2, 3, 4]"
                                >
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Status</span>
                                            </span>
                                        </template>
                                        <StatusDokumenPengadaanInfo
                                            :status="dataViewDokumenPengadaan.status"
                                        />
                                        
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Data Utama</span>
                                            </span>
                                        </template>
                                        <ViewAttribute
                                            :dataViewDokumenPengadaan="dataViewDokumenPengadaan"
                                        />
                                        <MetodePenyampaianForm
                                            v-model:metode="form.attribute.metode_penyampaian"
                                            v-model:bobot-teknis="form.attribute.bobot_teknis"
                                            v-model:bobot-harga="form.attribute.bobot_harga"
                                            v-model:bobot-keseluruhan="form.attribute.bobot_keseluruhan"
                                        />
                                    </AccordionTab>
                                    <AccordionTab v-if="dataViewDokumenPengadaan.config.includes('dokumen_pengadaan_file')">
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">File</span>
                                            </span>
                                        </template>
                                        <FileDisplay
                                            :existing_files="dataViewDokumenPengadaan.dokumen_pengadaan_file"
                                        />
                                    </AccordionTab>
                                    <AccordionTab v-if="dataViewDokumenPengadaan.config.includes('detail_hps')">
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Detail HPS</span>
                                            </span>
                                        </template>
                                        <DisplayHps
                                            :detail_hps="dataViewDokumenPengadaan.detail_hps"
                                        />
                                    </AccordionTab>
                                    <AccordionTab v-if="dataViewDokumenPengadaan.config.includes('jadwal')">
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Jadwal</span>
                                            </span>
                                        </template>
                                        <JadwalInput
                                            v-model:jadwals="form.jadwal"
                                        />
                                    </AccordionTab>
                                </Accordion>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import { defineComponent, reactive } from "vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import StatusDokumenPengadaanInfo from "@/Components/StatusDokumenPengadaanInfo";
import FileDisplay from "../../partials/FileDisplay.vue";
import ViewAttribute from "../../partials/ViewAttribute.vue";
import DisplayHps from "../../partials/DisplayHps.vue";
import JadwalInput from "../../partials/JadwalInput.vue";
import MetodePenyampaianForm from "../../partials/MetodePenyampaianForm.vue";

export default defineComponent({
    components: {
        AppLayout,
        Accordion,
        AccordionTab,
        StatusDokumenPengadaanInfo,
        FileDisplay,
        ViewAttribute,
        DisplayHps,
        JadwalInput,
        MetodePenyampaianForm,
    },
    props: {
        dataViewDokumenPengadaan: Object,
    },
    setup() {
        const form = reactive({
            attribute: {
                metode_penyampaian: '2f',
                bobot_teknis: 60,
                bobot_harga: 40,
                bobot_keseluruhan: 100,
            },
            jadwal: [],
        });

        return {
            form,
        };
    },
    mounted() {
        console.log("PenyusunanDokumenPemilihan mounted", this.dataViewDokumenPengadaan);
        // Initialize jadwal from dataViewDokumenPengadaan if available
        if (this.dataViewDokumenPengadaan?.jadwal) {
            this.form.jadwal = [...this.dataViewDokumenPengadaan.jadwal];
        }
    },
});
</script>